<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
html,body,#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* background-color: #d6eaff; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue